module.exports = __webpack_public_path__ + "img/img23.903a88bc.jpg";